import { useState, useEffect } from 'react';
import Button from '../Button/Button';
import './SaveGameControl.css';
import { playSound } from '../../utils/utils';

const SaveGameControl = ({ playerNamesState, disabled = false }) => {
  const [saveNameInput, setSaveNameInput] = useState('');
  const [buttonText, setButtonText] = useState('save Game');
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    const savedName = localStorage.getItem('currentSaveName');
    if (savedName) {
      setSaveNameInput(savedName);
    }
  }, []);

  const saveGameHandler = () => {
    const saves = JSON.parse(localStorage.getItem('savedGames')) || [];

    let saveName =
      typeof saveNameInput === 'string' && saveNameInput.trim() !== ''
        ? saveNameInput.trim()
        : null;

    if (!saveName) {
      let index = 1;
      const exists = (name) => saves.some((s) => s.name === name);

      while (exists(`Save ${index}`)) {
        index++;
      }
      saveName = `Save ${index}`;
    }

    const newSave = {
      name: saveName,
      data: playerNamesState,
      timestamp: new Date().toISOString(),
    };

    const existingIndex = saves.findIndex((s) => s.name === saveName);
    if (existingIndex !== -1) {
      saves[existingIndex] = newSave;
    } else {
      saves.push(newSave);
    }

    localStorage.setItem('savedGames', JSON.stringify(saves));

    setButtonText(`SAVED ✓`);
    setIsDisabled(true);
    playSound('/sounds/transition-to-next-page.mp3');
    setSaveNameInput('');
    localStorage.setItem('currentSaveName', saveName);
  };

  return (
    <div
      style={{
        marginTop: '50px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        alignItems: 'center',
      }}
    >
      {!isDisabled && (
        <input
          type="text"
          maxLength={10}
          placeholder="🎲 Enter save name (optional)"
          value={saveNameInput}
          onChange={(e) => setSaveNameInput(e.target.value)}
          className="saveInput"
          disabled={disabled}
        />
      )}
      <Button
        title={buttonText}
        type="smallSquare saveGame"
        handleClick={saveGameHandler}
        disabled={isDisabled || disabled}
      />
    </div>
  );
};

export default SaveGameControl;
